"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const expression_parser_1 = require("./expression-parser");
const syntax_1 = require("./error/syntax");
const node_1 = require("./node");
const token_1 = require("./token");
const text_1 = require("./node/text");
const print_1 = require("./node/print");
const body_1 = require("./node/body");
const module_1 = require("./node/module");
const node_traverser_1 = require("./node-traverser");
const token_parser_1 = require("./token-parser");
const first_1 = require("./helper/first");
const push_1 = require("./helper/push");
const comment_1 = require("./node/comment");
const ctype_space_1 = require("./helper/ctype_space");
const mt_rand = require('locutus/php/math/mt_rand');
const sha256 = require('crypto-js/sha256');
const hex = require('crypto-js/enc-hex');
class TwingParserStackEntry {
    constructor(stream, parent = null, blocks, blockStack, macros, importedSymbols, traits, embeddedTemplates) {
        this.stream = stream;
        this.parent = parent;
        this.blocks = blocks;
        this.blockStack = blockStack;
        this.macros = macros;
        this.importedSymbols = importedSymbols;
        this.traits = traits;
        this.embeddedTemplates = embeddedTemplates;
    }
}
class TwingParser {
    constructor(env) {
        this.stack = [];
        this.handlers = null;
        this.expressionParser = null;
        this.embeddedTemplates = [];
        this.varNameSalt = 0;
        this.env = env;
    }
    getVarName(prefix = '__internal_') {
        return `${prefix}${hex.stringify(sha256('TwingParser::getVarName' + this.stream.getSourceContext().getCode() + this.varNameSalt++))}`;
    }
    parse(stream, test = null, dropNeedle = false) {
        this.stack.push(new TwingParserStackEntry(this.stream, this.parent, this.blocks, this.blockStack, this.macros, this.importedSymbols, this.traits, this.embeddedTemplates));
        // tag handlers
        if (this.handlers === null) {
            this.handlers = new Map();
            for (let handler of this.env.getTokenParsers()) {
                handler.setParser(this);
                this.handlers.set(handler.getTag(), handler);
            }
        }
        // node visitors
        if (!this.visitors) {
            this.visitors = this.env.getNodeVisitors();
        }
        if (this.expressionParser === null) {
            this.expressionParser = new expression_parser_1.TwingExpressionParser(this, this.env);
        }
        this.stream = stream;
        this.parent = null;
        this.blocks = new Map();
        this.macros = new Map();
        this.traits = new Map();
        this.blockStack = [];
        this.importedSymbols = [new Map()];
        this.embeddedTemplates = [];
        this.varNameSalt = 0;
        let body;
        try {
            body = this.subparse(test, dropNeedle);
            if (this.parent !== null && (body = this.filterBodyNodes(body)) === null) {
                body = new node_1.TwingNode();
            }
        }
        catch (e) {
            if (e instanceof syntax_1.TwingErrorSyntax) {
                if (!e.getSourceContext()) {
                    e.setSourceContext(this.stream.getSourceContext());
                }
            }
            throw e;
        }
        let nodes = new Map();
        nodes.set(0, body);
        let node = new module_1.TwingNodeModule(new body_1.TwingNodeBody(nodes), this.parent, new node_1.TwingNode(this.blocks), new node_1.TwingNode(this.macros), new node_1.TwingNode(this.traits), this.embeddedTemplates, stream.getSourceContext());
        let traverser = new node_traverser_1.TwingNodeTraverser(this.env, this.visitors);
        node = traverser.traverse(node);
        // restore previous stack so previous parse() call can resume working
        let key;
        let stack = this.stack.pop();
        this.stream = stack.stream;
        this.parent = stack.parent;
        this.blocks = stack.blocks;
        this.blockStack = stack.blockStack;
        this.macros = stack.macros;
        this.importedSymbols = stack.importedSymbols;
        this.traits = stack.traits;
        this.embeddedTemplates = stack.embeddedTemplates;
        return node;
    }
    getExpressionParser() {
        return this.expressionParser;
    }
    getParent() {
        return this.parent;
    }
    setParent(parent) {
        this.parent = parent;
    }
    subparse(test, dropNeedle = false) {
        let lineno = this.getCurrentToken().getLine();
        let rv = new Map();
        let i = 0;
        let token;
        while (!this.stream.isEOF()) {
            switch (this.getCurrentToken().getType()) {
                case token_1.TwingToken.TEXT_TYPE:
                    token = this.stream.next();
                    rv.set(i++, new text_1.TwingNodeText(token.getValue(), token.getLine(), token.getColumn()));
                    break;
                case token_1.TwingToken.VAR_START_TYPE:
                    token = this.stream.next();
                    let expression = this.expressionParser.parseExpression();
                    this.stream.expect(token_1.TwingToken.VAR_END_TYPE);
                    rv.set(i++, new print_1.TwingNodePrint(expression, token.getLine(), token.getColumn()));
                    break;
                case token_1.TwingToken.BLOCK_START_TYPE:
                    this.stream.next();
                    token = this.getCurrentToken();
                    if (token.getType() !== token_1.TwingToken.NAME_TYPE) {
                        throw new syntax_1.TwingErrorSyntax('A block must start with a tag name.', token.getLine(), this.stream.getSourceContext());
                    }
                    if (test !== null && test[1](token)) {
                        if (dropNeedle) {
                            this.stream.next();
                        }
                        if (rv.size === 1) {
                            return first_1.first(rv);
                        }
                        return new node_1.TwingNode(rv, new Map(), lineno);
                    }
                    if (!this.handlers.has(token.getValue())) {
                        let e;
                        if (test !== null) {
                            e = new syntax_1.TwingErrorSyntax(`Unexpected "${token.getValue()}" tag`, token.getLine(), this.stream.getSourceContext());
                            if (Array.isArray(test) && (test.length > 1) && (test[0] instanceof token_parser_1.TwingTokenParser)) {
                                e.appendMessage(` (expecting closing tag for the "${test[0].getTag()}" tag defined near line ${lineno}).`);
                            }
                        }
                        else {
                            e = new syntax_1.TwingErrorSyntax(`Unknown "${token.getValue()}" tag.`, token.getLine(), this.stream.getSourceContext());
                            e.addSuggestions(token.getValue(), Array.from(this.env.getTags().keys()));
                        }
                        throw e;
                    }
                    this.stream.next();
                    let subparser = this.handlers.get(token.getValue());
                    let node = subparser.parse(token);
                    if (node !== null) {
                        rv.set(i++, node);
                    }
                    break;
                case token_1.TwingToken.COMMENT_START_TYPE:
                    this.stream.next();
                    token = this.stream.expect(token_1.TwingToken.TEXT_TYPE);
                    this.stream.expect(token_1.TwingToken.COMMENT_END_TYPE);
                    rv.set(i++, new comment_1.TwingNodeComment(token.getValue(), token.getLine(), token.getColumn()));
                    break;
                default:
                    throw new syntax_1.TwingErrorSyntax('Lexer or parser ended up in unsupported state.', this.getCurrentToken().getLine(), this.stream.getSourceContext());
            }
        }
        if (rv.size === 1) {
            return first_1.first(rv);
        }
        return new node_1.TwingNode(rv, new Map(), lineno);
    }
    getBlockStack() {
        return this.blockStack;
    }
    peekBlockStack() {
        return this.blockStack[this.blockStack.length - 1];
    }
    popBlockStack() {
        this.blockStack.pop();
    }
    pushBlockStack(name) {
        this.blockStack.push(name);
    }
    hasBlock(name) {
        return this.blocks.has(name);
    }
    getBlock(name) {
        return this.blocks.get(name);
    }
    setBlock(name, value) {
        let bodyNodes = new Map();
        bodyNodes.set(0, value);
        this.blocks.set(name, new body_1.TwingNodeBody(bodyNodes, new Map(), value.getTemplateLine()));
    }
    addTrait(trait) {
        push_1.push(this.traits, trait);
    }
    hasTraits() {
        return this.traits.size > 0;
    }
    embedTemplate(template) {
        template.setIndex(mt_rand());
        this.embeddedTemplates.push(template);
    }
    /**
     * @return {TwingToken}
     */
    getCurrentToken() {
        return this.stream.getCurrent();
    }
    /**
     *
     * @return {TwingTokenStream}
     */
    getStream() {
        return this.stream;
    }
    addImportedSymbol(type, alias, name = null, node = null) {
        let localScope = this.importedSymbols[0];
        if (!localScope.has(type)) {
            localScope.set(type, new Map());
        }
        let localScopeType = localScope.get(type);
        localScopeType.set(alias, { name: name, node: node });
    }
    getImportedSymbol(type, alias) {
        let result = null;
        this.importedSymbols.forEach(function (importedSymbol) {
            if (importedSymbol.has(type)) {
                let importedSymbolType = importedSymbol.get(type);
                if (importedSymbolType.has(alias)) {
                    result = importedSymbolType.get(alias);
                }
            }
        });
        return result;
    }
    hasMacro(name) {
        return this.macros.has(name);
    }
    setMacro(name, node) {
        this.macros.set(name, node);
    }
    isMainScope() {
        return this.importedSymbols.length === 1;
    }
    pushLocalScope() {
        this.importedSymbols.unshift(new Map());
    }
    popLocalScope() {
        this.importedSymbols.shift();
    }
    /**
     *
     * @param node
     * @param nested {boolean}
     * @returns {TwingNode}
     */
    filterBodyNodes(node, nested = false) {
        // check that the body does not contain non-empty output nodes
        if ((node.getType() === node_1.TwingNodeType.TEXT && !ctype_space_1.ctypeSpace(node.getAttribute('data'))) ||
            ((node.getType() !== node_1.TwingNodeType.TEXT) && (node.getType() !== node_1.TwingNodeType.BLOCK_REFERENCE) && (node.TwingNodeOutputInterfaceImpl) && (node.getType() !== node_1.TwingNodeType.SPACELESS))) {
            let nodeData = node.getAttribute('data');
            if (nodeData.indexOf(String.fromCharCode(0xEF, 0xBB, 0xBF)) > -1) {
                let trailingData = nodeData.substring(3);
                if (trailingData === '' || ctype_space_1.ctypeSpace(trailingData)) {
                    // bypass empty nodes starting with a BOM
                    return null;
                }
            }
            throw new syntax_1.TwingErrorSyntax(`A template that extends another one cannot include content outside Twig blocks. Did you forget to put the content inside a {% block %} tag?`, node.getTemplateLine(), this.stream.getSourceContext());
        }
        // bypass nodes that "capture" the output
        if (node.TwingNodeCaptureInterfaceImpl) {
            // a "block" tag in such a node will serve as a block definition AND be displayed in place as well
            return node;
        }
        // to be removed completely in Twig 3.0
        if (!nested && (node.getType() === node_1.TwingNodeType.SPACELESS)) {
            console.error(`Using the spaceless tag at the root level of a child template in "${this.stream.getSourceContext().getName()}" at line ${node.getTemplateLine()} is deprecated since Twig 2.5.0 and will become a syntax error in Twig 3.0.`);
        }
        // "block" tags that are not captured (see above) are only used for defining
        // the content of the block. In such a case, nesting it does not work as
        // expected as the definition is not part of the default template code flow.
        if (nested && (node.getType() === node_1.TwingNodeType.BLOCK_REFERENCE)) {
            console.error(`Nesting a block definition under a non-capturing node in "${this.stream.getSourceContext().getName()}" at line ${node.getTemplateLine()} is deprecated since Twig 2.5.0 and will become a syntax error in Twig 3.0.`);
            return null;
        }
        if (node.TwingNodeOutputInterfaceImpl && (node.getType() !== node_1.TwingNodeType.SPACELESS)) {
            return null;
        }
        // here, nested means "being at the root level of a child template"
        // we need to discard the wrapping "TwingNode" for the "body" node
        nested = nested || (node.getType() !== null);
        for (let [k, n] of node.getNodes()) {
            if (n !== null && (this.filterBodyNodes(n, nested) === null)) {
                node.removeNode(k);
            }
        }
        return node;
    }
}
exports.TwingParser = TwingParser;
